import { Component } from '@angular/core';
import { NgClass, NgFor } from '@angular/common';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { ContextMenuComponent, MenuComponent } from '@progress/kendo-angular-menu';
import { Button } from '@progress/kendo-angular-buttons';
import { FormsModule } from "@angular/forms";
import { menuLinks } from "./header-menu-items";
import { KENDO_PANELBAR } from '@progress/kendo-angular-layout';
import { MediaMatcher } from '@angular/cdk/layout';
import { filter } from 'rxjs/internal/operators/filter';
import { AvatarComponent } from "../../shared/components/avatar/avatar.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgClass, NgFor, RouterLink, MenuComponent, Button, FormsModule, KENDO_PANELBAR, AvatarComponent, ContextMenuComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  menuLinks: any[] = menuLinks;

  // Search form
  headerSearchField: string = '';

  isMenuVisible: boolean = false;

  // for lazy loading
  isScreenTablet: boolean = false;
  isScreenMobile: boolean = false;

  isUserLoggedIn: boolean = true; // for demo purpose

  // for user profile menu
  profileMenuLinks: any[] = [
    {
      text: "Dashboard",
      url: '/'
    },
    {
      text: "Profile",
      url: '/profile/basic'
    },
    {
      text: "Settings",
      url: '/'
    },
    { separator: true },
    {
      text: "Logout",
      url: '/'
    }
  ];

  constructor (
    private mediaMatcher: MediaMatcher,
    private router: Router
  ) {
    const isScreenTablet = this.mediaMatcher.matchMedia('(min-width: 992.98px)');
    this.isScreenTablet = isScreenTablet.matches;
    const isScreenMobile = this.mediaMatcher.matchMedia('(min-width: 768.98px)');
    this.isScreenMobile = isScreenMobile.matches;

    // for responsive menu visibility on smaller screen
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isMenuVisible = false;
      });
  }

  toggleMenu () {
    this.isMenuVisible = !this.isMenuVisible;
  }

}
